/**
 * The 7-Day NOKI Reset: what the $9 Founding Pass delivers the moment it is paid.
 * Seven guided real-life Side Quests, one a day, each with a short "why" and one thing to notice.
 * The Worker keeps the same titles for the daily emails (worker/program.ts).
 */
export interface ProgramDay {
  day: number;
  theme: string;
  title: string;
  why: string;
  quest: string;
  notice: string;
  minutes: number;
}

export const PROGRAM: ProgramDay[] = [
  { day: 1, theme: "Outside", title: "Meet the day", minutes: 5,
    why: "Autopilot lives indoors, one screen away. Daylight is the fastest way back into your own life.",
    quest: "Step outside for five minutes. No headphones, no feed. Walk to a spot where you can see the sky and stay there.",
    notice: "What is one thing out there you would never have seen through a screen?" },
  { day: 2, theme: "People", title: "Reach toward someone", minutes: 5,
    why: "Scrolling feels social and leaves you lonelier. One real message does the opposite.",
    quest: "Send one person a real message: something you appreciate about them, a memory, or a question you actually want answered. Voice note counts.",
    notice: "How did it feel waiting for a real reply instead of a like?" },
  { day: 3, theme: "Move", title: "Shake off the static", minutes: 7,
    why: "The pull to scroll often shows up when your body has been still too long.",
    quest: "Move for seven minutes in any way that feels good: stairs, a lap around the block, stretching, dancing in the kitchen.",
    notice: "Did the urge to check your phone change after you moved?" },
  { day: 4, theme: "Create", title: "Make one rough thing", minutes: 10,
    why: "The feed shows you what others made. Making something tiny yourself feels completely different.",
    quest: "Spend ten minutes making something that did not exist before: a sketch, a paragraph, a photo you frame on purpose, a meal with one new ingredient. It is allowed to be bad.",
    notice: "Where did your attention go while your hands were busy?" },
  { day: 5, theme: "Read", title: "Follow one thought", minutes: 10,
    why: "Swipes train short attention. Ten minutes on one page trains it back.",
    quest: "Read something that lasts for ten minutes: a book, a long article you saved, a chapter you keep meaning to finish. Phone in another room.",
    notice: "Did ten minutes feel longer or shorter than ten minutes of scrolling?" },
  { day: 6, theme: "Calm", title: "Let the moment catch up", minutes: 5,
    why: "Most scrolling is a way to avoid five empty minutes. Today you keep the five minutes.",
    quest: "Sit near a window or outside for five minutes with no input at all. Let your eyes rest on something far away.",
    notice: "What came up when there was nothing to fill the space?" },
  { day: 7, theme: "Your pick", title: "Choose your own quest", minutes: 10,
    why: "The point of NOKI is not our list. It is you choosing your life on purpose.",
    quest: "Look back at the week and pick the quest that felt best, or invent one. Do it for ten minutes, then write one line about the week.",
    notice: "Which moment this week do you want more of, and when does autopilot usually steal it?" },
];
